// extracted by mini-css-extract-plugin
module.exports = {"column":"styles-module__column___12eLv","or-column":"styles-module__or-column___3Z6Ot"};